import React from 'react';

const Loading = () => {
	return (
		<>
			<div className='loader-container'>
				<div className='loader-logo'>
					<div className='sk-chase'>
						<div className='sk-chase-dot'></div>
						<div className='sk-chase-dot'></div>
						<div className='sk-chase-dot'></div>
						<div className='sk-chase-dot'></div>
						<div className='sk-chase-dot'></div>
						<div className='sk-chase-dot'></div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Loading;
